<!-- PWAPrompt.vue -->
<template>
    <div v-if="shown">
        <div id="install_banner">
            <v-container>
                <v-row style="align-items: center">
                    <span>Install eReader to home screen?</span>
                    <v-spacer></v-spacer>

                    <button @click="installPWA">Yes</button>

                    <button @click="dismissPrompt">No</button>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        shown: false,
    }),

    beforeMount() {
        window.addEventListener("beforeinstallprompt", e => {
            e.preventDefault();
            this.installEvent = e;
            this.shown = true;
        });
    },

    methods: {
        dismissPrompt() {
            this.shown = false;
        },

        installPWA() {
            this.installEvent.prompt();
            this.installEvent.userChoice.then(choice => {
                this.dismissPrompt(); // Hide the prompt once the user's clicked
                if (choice.outcome === "accepted") {
                    // Do something additional if the user chose to install
                } else {
                    // Do something additional if the user declined
                }
            });
        },
    },
};
</script>
